import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({ name: 'relativeTime', standalone: true, pure: false })
export class RelativeTimePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (!value) return '';

    const now  = Date.now();
    const date = new Date(value).getTime();
    const diff = Math.floor((now - date) / 1000); // seconds

    if (diff < 60)              return 'À l\'instant';
    if (diff < 3600)            return `Il y a ${Math.floor(diff / 60)} min`;
    if (diff < 86400)           return `Il y a ${Math.floor(diff / 3600)} h`;
    if (diff < 86400 * 2)       return 'Hier';
    if (diff < 86400 * 7)       return `Il y a ${Math.floor(diff / 86400)} j`;

    return new Date(value).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' });
  }
}
